var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.611,
    height: 16.489,
    viewBox: "0 0 20.611 16.489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-mail-outline",
    "data-name": "Icon material-mail-outline",
    d: "M21.55,6H5.061A2.058,2.058,0,0,0,3.01,8.061L3,20.428a2.067,2.067,0,0,0,2.061,2.061H21.55a2.067,2.067,0,0,0,2.061-2.061V8.061A2.067,2.067,0,0,0,21.55,6Zm0,14.428H5.061V10.122l8.244,5.153,8.244-5.153Zm-8.244-7.214L5.061,8.061H21.55Z",
    transform: "translate(-3 -6)",
    fill: "#0154ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOutline);
export default __webpack_public_path__ + "static/media/mail-outline.6fa7eec35ef1a4ccdf7c01615144144a.svg";
export { ForwardRef as ReactComponent };